// extracted by mini-css-extract-plugin
export var cardLayout = "_68-1";
export var paginationContainer = "_68-0";